import React from 'react'

export const Icons = {
  LeftAlignment: (props: React.ComponentProps<'svg'>) => (
    <svg
      height="100%"
      viewBox="0 0 93 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H90.6667C91.7712 0 92.6667 0.895431 92.6667 2V14C92.6667 15.1046 91.7712 16 90.6667 16H2C0.895429 16 0 15.1046 0 14V2Z"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M0 26C0 24.8954 0.895431 24 2 24H46C47.1046 24 48 24.8954 48 26V34C48 35.1046 47.1046 36 46 36H2C0.895431 36 0 35.1046 0 34V26Z"
        fill="white"
        fillOpacity="0.15"
      />
    </svg>
  ),
  CenterAlignment: (props: React.ComponentProps<'svg'>) => (
    <svg
      height="100%"
      viewBox="0 0 94 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.666992" width="92.6667" height="16" rx="2" fill="white" fillOpacity="0.15" />
      <rect x="23" y="24" width="48" height="12" rx="2" fill="white" fillOpacity="0.15" />
    </svg>
  ),
  RightAlignment: (props: React.ComponentProps<'svg'>) => (
    <svg
      height="100%"
      viewBox="0 0 93 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.333008" width="92.6667" height="16" rx="2" fill="white" fillOpacity="0.15" />
      <rect x="45" y="24" width="48" height="12" rx="2" fill="white" fillOpacity="0.15" />
    </svg>
  ),
  InlineBlock: (props: React.ComponentProps<'svg'>) => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 190 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 4C0 2.89543 0.895431 2 2 2H102C103.105 2 104 2.89543 104 4V16C104 17.1046 103.105 18 102 18H2C0.895432 18 0 17.1046 0 16V4Z"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M110.88 12.536C110.496 12.536 110.171 12.408 109.904 12.152C109.637 11.8853 109.504 11.5547 109.504 11.16C109.504 10.7653 109.637 10.44 109.904 10.184C110.171 9.91733 110.496 9.784 110.88 9.784C111.264 9.784 111.589 9.91733 111.856 10.184C112.123 10.44 112.256 10.7653 112.256 11.16C112.256 11.5547 112.123 11.8853 111.856 12.152C111.589 12.408 111.264 12.536 110.88 12.536Z"
        fill="white"
      />
      <path
        d="M118 4C118 2.89543 118.895 2 120 2H188C189.105 2 190 2.89543 190 4V16C190 17.1046 189.105 18 188 18H120C118.895 18 118 17.1046 118 16V4Z"
        fill="white"
        fillOpacity="0.15"
      />
    </svg>
  ),
  CommaSeparated: (props: React.ComponentProps<'svg'>) => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 93 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.2"
        d="M0 2C0 0.89543 0.895431 0 2 0H33.3333C34.4379 0 35.3333 0.895431 35.3333 2V22C35.3333 23.1046 34.4379 24 33.3333 24H2C0.895429 24 0 23.1046 0 22V2Z"
        fill="url(#paint0_linear_2544_16701)"
      />
      <path
        d="M46.3055 13C47.1862 13 47.9018 13.277 48.4523 13.8311C49.0394 14.3526 49.333 15.0859 49.333 16.0311C49.333 17.6933 48.8376 19.2089 47.8468 20.5778C46.8926 21.9793 45.8651 23.12 44.7642 24L43.8284 22.8756C44.3789 22.2563 44.8559 21.5881 45.2596 20.8711C45.6633 20.1541 45.9202 19.3067 46.0303 18.3289C45.2596 18.2637 44.6174 17.9867 44.1036 17.4978C43.5899 16.9763 43.333 16.357 43.333 15.64C43.333 14.8904 43.6266 14.2711 44.2137 13.7822C44.8009 13.2607 45.4981 13 46.3055 13Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M57.333 2C57.333 0.89543 58.2284 0 59.333 0H90.6663C91.7709 0 92.6663 0.895431 92.6663 2V22C92.6663 23.1046 91.7709 24 90.6663 24H59.333C58.2284 24 57.333 23.1046 57.333 22V2Z"
        fill="url(#paint1_linear_2544_16701)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2544_16701"
          x1="0"
          y1="12"
          x2="35.3333"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#585E6B" stopOpacity="0" />
          <stop offset="1" stopColor="#F9FAFA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2544_16701"
          x1="57.333"
          y1="12"
          x2="92.6663"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9FAFA" />
          <stop offset="1" stopColor="#585E6B" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  Columns: (props: React.ComponentProps<'svg'>) => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 94 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="3.66699" cy="8" r="3" fill="white" />
      <rect
        opacity="0.2"
        x="10.667"
        width="82.6667"
        height="16"
        rx="2"
        fill="url(#paint0_linear_2544_16708)"
      />
      <circle cx="3.66699" cy="32" r="3" fill="white" />
      <rect
        opacity="0.2"
        x="10.667"
        y="24"
        width="82.6667"
        height="16"
        rx="2"
        fill="url(#paint1_linear_2544_16708)"
      />
      <circle cx="3.66699" cy="56" r="3" fill="white" />
      <rect
        opacity="0.2"
        x="10.667"
        y="48"
        width="82.6667"
        height="16"
        rx="2"
        fill="url(#paint2_linear_2544_16708)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2544_16708"
          x1="10.667"
          y1="8"
          x2="93.3337"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9FAFA" />
          <stop offset="1" stopColor="#585E6B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2544_16708"
          x1="10.667"
          y1="32"
          x2="93.3337"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9FAFA" />
          <stop offset="1" stopColor="#585E6B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2544_16708"
          x1="10.667"
          y1="56"
          x2="93.3337"
          y2="56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9FAFA" />
          <stop offset="1" stopColor="#585E6B" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  Categories: (props: React.ComponentProps<'svg'>) => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 71 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V18C32 19.1046 31.1046 20 30 20H2C0.895431 20 0 19.1046 0 18V2Z"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M36.024 14.723C36.392 14.723 36.691 14.8533 36.921 15.114C37.1663 15.3593 37.289 15.7043 37.289 16.149C37.289 16.931 37.082 17.644 36.668 18.288C36.2693 18.9473 35.84 19.484 35.38 19.898L34.989 19.369C35.219 19.0777 35.4183 18.7633 35.587 18.426C35.7557 18.0887 35.863 17.69 35.909 17.23C35.587 17.1993 35.3187 17.069 35.104 16.839C34.8893 16.5937 34.782 16.3023 34.782 15.965C34.782 15.6123 34.9047 15.321 35.15 15.091C35.3953 14.8457 35.6867 14.723 36.024 14.723Z"
        fill="white"
      />
      <path
        d="M39 2C39 0.895431 39.8954 0 41 0H69C70.1046 0 71 0.895431 71 2V18C71 19.1046 70.1046 20 69 20H41C39.8954 20 39 19.1046 39 18V2Z"
        fill="white"
        fillOpacity="0.15"
      />
    </svg>
  ),
}
